import { DeviceType } from '~/services/api/enums';
import { Timezone } from '~/types';
import { getCurrentMonthFirstDayDate, getCurrentMonthLastDayDate } from '~/utils/date';

export const getInitialFilters = (timezone: Timezone) => ({
  startDate: getCurrentMonthFirstDayDate(timezone),
  endDate: getCurrentMonthLastDayDate(timezone),
  deviceTypeId: null as DeviceType,
});

export default {};
